import type { RootState } from '../types/store';
import getActiveSubscriptions from './active-subscriptions';
import messenger from '../messenger';
import type { Subscription } from '../types/subscription';
import isEcommercePlanType from '../verifiers/is-ecommerce-plan-type';

function getActiveEcommerceSubscription(state: RootState): Subscription | null {
  const activeSubscriptions = getActiveSubscriptions(state);

  if (!activeSubscriptions) throw new Error(messenger.missingData('active'));

  const currentEcommerceSubscription = activeSubscriptions.find((subscription: Subscription) =>
    isEcommercePlanType(subscription.type)
  );

  return currentEcommerceSubscription || null;
}

export default getActiveEcommerceSubscription;
